module.exports = __webpack_public_path__ + "assets/img/redpacket-bg2.5830ad52.png";